import React, { useEffect, useRef, useState } from 'react';
import Icon from '../AppIcon';
import useTranslation from '../../hooks/useTranslation';

// 4 lignes de text-sm (20 px) + le padding vertical du champ (2 x 10 px).
const MAX_HEIGHT = 100;

/**
 * Barre de saisie. Entree envoie, Maj+Entree passe a la ligne. Micro et piece
 * jointe : visuels en v1, un clic affiche « Bientot disponible » sous la barre.
 */
const OnXInput = ({ onSend, isLoading }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  const [comingSoon, setComingSoon] = useState(false);
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  // Le champ, desactive pendant l'attente, reprend le focus a la reponse.
  useEffect(() => {
    if (!isLoading) inputRef.current?.focus();
  }, [isLoading]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const resize = (el) => {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, MAX_HEIGHT)}px`;
  };

  const handleSend = () => {
    const text = input.trim();
    if (!text || isLoading) return;
    onSend(text);
    setInput('');
    if (inputRef.current) inputRef.current.style.height = 'auto';
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const showComingSoon = () => {
    setComingSoon(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setComingSoon(false), 2000);
  };

  const iconBtn = 'flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors';

  return (
    <div className="border-t border-gray-200 bg-background px-6 py-3 flex-shrink-0">
      <div className="max-w-[800px] mx-auto">
        <div className="flex items-end gap-2">
          <button type="button" onClick={showComingSoon} className={iconBtn} title={t('onx.comingSoon')}>
            <Icon name="Paperclip" size={18} />
          </button>
          <textarea
            ref={inputRef}
            value={input}
            rows={1}
            onChange={(e) => { setInput(e.target.value); resize(e.target); }}
            onKeyDown={handleKeyDown}
            placeholder={t('onx.placeholder')}
            disabled={isLoading}
            className="flex-1 resize-none rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:bg-gray-50"
            style={{ maxHeight: MAX_HEIGHT, minHeight: 40 }}
          />
          <button type="button" onClick={showComingSoon} className={iconBtn} title={t('onx.comingSoon')}>
            <Icon name="Mic" size={18} />
          </button>
          <button
            type="button"
            onClick={handleSend}
            disabled={!input.trim() || isLoading}
            title={t('onx.send')}
            aria-label={t('onx.send')}
            className="flex-shrink-0 w-9 h-9 rounded-full bg-primary hover:bg-[#E85D1F] text-white flex items-center justify-center transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <Icon name="ArrowUp" size={16} />
          </button>
        </div>
        {comingSoon && (
          <p className="text-[11px] text-gray-400 mt-1.5 text-center">{t('onx.comingSoon')}</p>
        )}
      </div>
    </div>
  );
};

export default OnXInput;
